import { Suspense, useCallback, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { HashRouter, Route, Switch, useHistory, Redirect } from 'react-router-dom'
import { sendFCMTokenToBE } from './api/customerInfo/index'
import IsLoggedIn from './api/login'
import ActionInfoDialog from './components/actionInfoDialog'
import GlobalChatWidget from './components/globalChatWidget'
import CustomNotification from './components/notification/customNotification'
import routingMappingDic from './components/search/routingDictionary'
import DirLayout from './layouts/dirLayout'
import PrivateLayout from './layouts/privateLayout'
import {
  AboutApp,
  AllOffersPage,
  SpeedUpgradeSummary,
  SpeedUpgradeADSL,
  BillsDetailsPage,
  BundleAndOfferPage,
  BundleDetailsPage,
  CampaignOfferGiftsPage,
  CampaignOfferNoGiftsPage,
  CallUsPage,
  connectYourLine,
  CorporateLineService,
  CorporateTempDeactivateAndReconnect,
  CountryInfoPage,
  devices,
  FollowUpPage,
  FreeMessages,
  Home,
  IndividualServicePage,
  InternationalRoaming,
  JawwalApps,
  JPCallBack,
  LandingPage,
  Main,
  MainCorporate,
  MCNPage,
  microLoans,
  More,
  NumberDetails,
  Orders,
  OfferDetailsPage,
  PayBills,
  PlanDetails,
  profile,
  AddReflectInfo,
  RatingPage,
  RechargeBalance,
  SelectedNumber,
  selectYourNumber,
  Service,
  ServiceFiltrationPage,
  Settings,
  Share,
  ShowRoomsPage,
  Store,
  SubAccountPage,
  SubscribersPage,
  SupportAndHelp,
  SupportAndHelpIframePage,
  TroubleTicketPage,
  SwipeSim,
  SwitchNumbers,
  temporaryDeactivation,
  TermsAndCondition,
  test,
  TipsPage,
  TransactionHistory,
  TransferBalance,
  callMeBack,
  simSwap,
  balanceHistory,
  giftSharing,
  selectGift,
  Gifts,
  termsAndConditions,
  TermsAndConditions,
  usage,
  // eslint-disable-next-line prettier/prettier
  VasService,
  DeviceManagement,
  quickAccess,
  Fiber,
  FiberMigrationTermsConditions,
  FiberTool,
  FamilyRoaming,
  CountrySelectionPage,
  FamilyRoamingSummary,
  
  ZerosServicePage,
  MobileZeros,
  InternationalZeros,
  FixedLinesServicesPage,
  ChangeLocationPage,
  ChangeNumberPage,
  BillServicesPage,
  EBillPage,
  BillviaSMS,
  ServiceDetails,
  UsageDetailsPage,
  PaltelBook,
  ChangeLocationTermsAndConditions,
  UberPage,
  OrderTracking,
  OrderTrackingDetails,
  FixedFollowUpRouter,
  Points,
  NewSubscriptionRequest,
  OtpVerification,
  NewSubscriptionRequestMap,
  SuperfastInternet,
  SuperfastInternetAddOns,
  SuperfastInternetSummary,
  RecurringPayment,
  RecurringPaymentTerms,
  CardsManagement,
  MainCorporatePage,
  PaltelMainCorporate,
  PaltelSubscribersPage,
  PaltelAccountInfo,
  AddTroubleTicketFixedLine,
  AddTroubleTicketDataIP,
  AddFollowUp,
  InvoiceDetails,
  PaltelOrders,
  Maddedha,
  SIMPUKCode,
  RamadanOffers,
  RamadanBundlesBalances,
  CampaignDetails,
  BaringCalls,
  InsatllmentDetails,
  LineInstallmentPage,
  DirectDebt,
  DirectDebtServicePage,
  RouterSettings,
  BundleGifting,
  PaltelInstallations,
  PayBillsOthers,
} from './pages'
import PAGES_LINKS from './pages/constants'
import { getBundlesData } from './redux/bundle/actions'
import { getBillsInfo, getCustomerInfo } from './redux/customerInfo/actions'
import { getPaltelCustomerInfo } from './redux/fixedLineCustomerInfo/actions'
import './styles/global.scss'
import { callAnalyticsEvent } from './utils/analyticsEvent'
import CONSTANTS from './utils/constants'
import { createTrace, requestForToken } from './utils/fireBaseMessagingConfig'
import { decrypt } from './utils/security'
import { deleteCookie, getCookieValue } from './utils/utils'
import { startTrace, stopTrace } from './redux/trace/actions'
import { getFixedLineSOHOCustomerInfo } from './redux/fixedLineSOHOCustomerInfo/actions'
const messageChannel = new BroadcastChannel('receive_message_channel')
function App() {
  const history = useHistory()
  const dispatch = useDispatch()
  const [translation] = useTranslation(['common'])
  const {
    Mode,
    Language,
    CustomerInfoData: { customerInfo },
    PaltelcustomerInfoData: { paltelCustomerInfo },
    fixedLineSOHOCustomerInfoData: { sohoCustomerInfo },
    bundleInfo: { bundleData },
  } = useSelector((state) => state)
  const dir = Language.selectedLanguage === 'AR' ? 'rtl' : 'ltr'
  const [openUpdateDialog, setOpenUpdateDialog] = useState(false)
  const [notificationRouteId, setNotificationRouteId] = useState('')
  const [isUsingMainNumber, setIsUsingMainNumber] = useState(true)
  const [msgDialog, setMsgDialog] = useState('')
  const isFcmTokenSend = !!localStorage.getItem('isFcmTokenSend')
  const prevLang = useRef(Language.selectedLanguage)
  const isPaltelCustomer = JSON.parse(localStorage.getItem('isPaltelCustomer'))
  const customerType = JSON.parse(localStorage.getItem('customerType'))

  useEffect(() => {
    document.title = translation('jawwal')
  }, [translation])

  useEffect(() => {
    if (customerType === 1) {
      if (
        !sohoCustomerInfo.loaded &&
        !sohoCustomerInfo.isLoading &&
        IsLoggedIn()
      ) {
        getFixedLineSOHOCustomerInfo(dispatch)
      }
    } else if (customerType === 2) {
      if (
        !paltelCustomerInfo.loaded &&
        !paltelCustomerInfo.isLoading &&
        IsLoggedIn()
      ) {
        getPaltelCustomerInfo(dispatch)
        dispatch(
          startTrace(
            createTrace('web_paltel_logged_in_open_app'),
            'web_paltel_logged_in_open_app'
          )
        )
        return () => {
          dispatch(stopTrace('web_paltel_logged_in_open_app'))
        }
      }
    } else {
      if (!customerInfo.loaded && !customerInfo.isLoading && IsLoggedIn()) {
        getCustomerInfo(dispatch)
        dispatch(
          startTrace(
            createTrace('web_jawwal_logged_in_open_app'),
            'web_jawwal_logged_in_open_app'
          )
        )
        return () => {
          dispatch(stopTrace('web_jawwal_logged_in_open_app'))
        }
      }
    }
  }, [dispatch, paltelCustomerInfo, customerInfo, sohoCustomerInfo])

  // Call GetAvailablePopup with trigger=open when app opens (not first time after login)
  useEffect(() => {
    if (prevLang.current !== Language.selectedLanguage && IsLoggedIn()) {
      if (customerType === 1) {
        getFixedLineSOHOCustomerInfo(dispatch)
      } else if (customerType === 2) {
        getPaltelCustomerInfo(dispatch)
      } else {
        getCustomerInfo(dispatch)
      }
      prevLang.current = Language.selectedLanguage
    }
  }, [Language.selectedLanguage, dispatch])

  const callNotificationEvent = useCallback(
    (actionName = 'notificationReceive', body) => {
      callAnalyticsEvent(actionName, customerInfo?.result?.msisdn, {
        ...(body && { notification_MSG: body }),
      })
    },
    [customerInfo?.result?.msisdn]
  )
  const getPagesNotAllowedUserToNavigate = useCallback(() => {
    const rolesShouldBeRemoved = []
    if (
      customerInfo?.result?.customerPaymentType === CONSTANTS.PREPAID &&
      !parseInt(customerInfo?.result?.dueAmmounts, 10)
    ) {
      rolesShouldBeRemoved.push(10009)
    }
    if (
      customerInfo?.result?.myNumbers?.length === 0 ||
      !!decrypt(getCookieValue('switchToken'))
    ) {
      rolesShouldBeRemoved.push(40017)
    }
    if (
      (bundleData?.others?.sms?.length === 0 &&
        bundleData?.others?.minutes?.length === 0 &&
        bundleData?.others?.balance?.length === 0) ||
      bundleData.error
    ) {
      rolesShouldBeRemoved.push(10005)
    }
    if (!customerInfo?.result?.isCorpAutherized) {
      rolesShouldBeRemoved.push(40008)
    }
    return rolesShouldBeRemoved
  }, [bundleData, customerInfo])

  useEffect(() => {
    const onMessage = (event) => {
      if (event.data.type === 'NOTIFICATION_CLICK') {
        let pagesCantNavigate = getPagesNotAllowedUserToNavigate()
        let isUserNotAllowedToNavigate =
          pagesCantNavigate.filter(
            (routeId) => routeId === parseInt(event.data.ticketId)
          ).length > 0

        if (decrypt(getCookieValue('switchToken'))) {
          window.open(
            `/#${routingMappingDic[10000]}?routeKey=${event.data.ticketId}`
          )
        } else {
          window.open(
            `/#${
              routingMappingDic[
                event.data.ticketId &&
                !isUserNotAllowedToNavigate &&
                routingMappingDic[parseInt(event.data.ticketId)]
                  ? parseInt(event.data.ticketId)
                  : 10000
              ]
            }`
          )
        }
        callNotificationEvent(event?.data?.body)
        if (isPaltelCustomer) {
          callNotificationEvent('notificationReadFixedline', event?.data?.body)
        } else {
          callNotificationEvent('notificationRead', event?.data?.body)
        }
      } else if (event.data.type === 'NOTIFICATION_RECEIVED_IN_BG') {
        if (isPaltelCustomer) {
          callNotificationEvent('notificationForegroundFixedline')
        } else {
          callNotificationEvent('notificationForeground')
        }
      } else if (event.data.type === 'NOTIFICATION_CLOSE') {
      }
    }

    messageChannel.addEventListener('message', onMessage)

    return () => {
      messageChannel.removeEventListener('message', onMessage)
    }
  }, [
    history,
    dispatch,
    getPagesNotAllowedUserToNavigate,
    callNotificationEvent,
  ])

  useEffect(() => {
    ;(async () => {
      if (!isFcmTokenSend && decrypt(getCookieValue('refreshToken'))) {
        let token = await requestForToken()
        if (token) {
          await sendFCMTokenToBE(token)
          localStorage.setItem('isFcmTokenSend', 'yes')
        }
      }
    })()
  }, [isFcmTokenSend, dispatch])

  const openDialogToUpdatePages = (
    action = 'onReceive',
    isUserSwitchAccount
  ) => {
    if (!isUserSwitchAccount) {
      setMsgDialog('apply_changes_receive_from_notifications')
      setOpenUpdateDialog(true)
    } else if (action === 'onClick' && isUserSwitchAccount) {
      setOpenUpdateDialog(true)
    }
  }
  const handleForeGroundOnClickNotification = (isUserSwitch) => {
    if (isUserSwitch) {
      setMsgDialog('ask_to_return_main_number')
      setOpenUpdateDialog(true)
      setIsUsingMainNumber(false)
    } else {
      setIsUsingMainNumber(true)
      updatePageDueNotification()
    }
  }
  const updatePageDueNotification = () => {
    switch (notificationRouteId) {
      case 10009:
        if (customerType === 3) {
          getCustomerInfo(dispatch)
        } else if (customerType === 2) {
          getPaltelCustomerInfo(dispatch)
        } else {
          getFixedLineSOHOCustomerInfo(dispatch)
        }
        getBillsInfo(dispatch)
        break
      case 10010:
      case 20009:
        if (customerType === 3) {
          getCustomerInfo(dispatch)
        } else if (customerType === 2) {
          getPaltelCustomerInfo(dispatch)
        } else {
          getFixedLineSOHOCustomerInfo(dispatch)
        }
        break
      case 10002:
      case 10003:
      case 10004:
      case 10005:
        getBundlesData(dispatch)
        window.location.reload(true)
        break
      case 10001:
        if (customerType === 3) {
          getCustomerInfo(dispatch)
        } else if (customerType === 2) {
          getPaltelCustomerInfo(dispatch)
        } else {
          getFixedLineSOHOCustomerInfo(dispatch)
        }
        window.location.reload(true)
        break
      default:
        window.location.reload(true)
        break
    }
    setOpenUpdateDialog(false)
  }

  const handleOnConfirmActionOnUpdateDialog = () => {
    if (isUsingMainNumber) {
      updatePageDueNotification()
    } else {
      deleteCookie('switchToken')
      if (window.location.hash.replace('#', ' ') === '/home') {
        window.location.reload(true)
        setOpenUpdateDialog(false)
      } else {
        let pagesCantNavigate = getPagesNotAllowedUserToNavigate()
        let isUserNotAllowedToNavigate =
          pagesCantNavigate.filter((routeId) => routeId === notificationRouteId)
            .length > 0
        if (isPaltelCustomer) {
          getPaltelCustomerInfo(dispatch)
        } else {
          getCustomerInfo(dispatch)
        }
        window.location.href = `/#${
          routingMappingDic[
            notificationRouteId &&
            !isUserNotAllowedToNavigate &&
            routingMappingDic[notificationRouteId]
              ? notificationRouteId
              : 10000
          ]
        }`
        setOpenUpdateDialog(false)
      }
    }
  }
  useEffect(() => {
    if (window.location.hash.split('?')[0].replace('#', '') === '/home') {
      const routeId = window.location.hash
        .substring(window.location.hash.lastIndexOf('?') + 1)
        .split('=')[1]
      if (routeId) {
        setNotificationRouteId(parseInt(routeId))
        setMsgDialog('ask_to_return_main_number')
        setOpenUpdateDialog(true)
        setIsUsingMainNumber(false)
      }
    }
  }, [])

  return (
    <>
      <CustomNotification
        openUpdateDialogCallBack={openDialogToUpdatePages}
        updatePageDueNotificationCallBack={handleForeGroundOnClickNotification}
        callNotificationEventCallBack={callNotificationEvent}
        getPagesNotAllowedUserToNavigateCallBack={
          getPagesNotAllowedUserToNavigate
        }
        setRouteIdCallBack={(notificationRouteId) =>
          setNotificationRouteId(notificationRouteId)
        }
      />
      <ActionInfoDialog
        shouldOpen={openUpdateDialog}
        mode={Mode.selectedMode}
        dir={dir}
        data={translation(msgDialog)}
        actionText={translation('confirmation')}
        handleCallBack={() => handleOnConfirmActionOnUpdateDialog()}
        classes="app-info-dialog-container"
        closeButtonText={translation('cancel')}
        shouldCloseCallBack={() => setOpenUpdateDialog(false)}
      />
      <DirLayout>
        <Suspense fallback={<></>}>
          <HashRouter>
            <GlobalChatWidget />
            <Switch>
              <PrivateLayout
                exact
                path={PAGES_LINKS.landingPage}
                component={LandingPage}
              />
              <PrivateLayout
                exact
                path={PAGES_LINKS.home.root}
                component={Home}
              />
              <PrivateLayout
                exact
                path={PAGES_LINKS.home.rechargeSuccess}
                paymentInfoType="paymentComplete"
                paymentResultOpen={true}
                successLabel="successfullyRecharged"
                successDescription={translation('successfullyRechargedDesc')}
                component={Home}
                isJPAY
              />
              <PrivateLayout
                exact
                path={PAGES_LINKS.home.invoicedSuccess}
                paymentInfoType="paymentComplete"
                paymentResultOpen={true}
                successLabel="successfullyPaid"
                successDescription={translation('successfullyPaidInvoiceJPay')}
                component={Home}
                isJPAY
              />
              <PrivateLayout
                exact
                path={PAGES_LINKS.more.root}
                component={More}
              />
              <PrivateLayout exact path={PAGES_LINKS.store} component={Store} />
              <PrivateLayout
                exact
                path={PAGES_LINKS.service.root}
                component={Service}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.bundlePage}`}
                component={BundleAndOfferPage}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.vas}`}
                component={VasService}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.temporaryDeactivation}`}
                component={temporaryDeactivation}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.transferBalance}`}
                component={TransferBalance}
              />
              <PrivateLayout
                exact
                path={[
                  `${PAGES_LINKS.service.root}${PAGES_LINKS.service.selectedNumber}`,
                  `${PAGES_LINKS.service.root}${PAGES_LINKS.service.selectedNumberCampaign}`,
                ]}
                component={SelectedNumber}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.selectYourNumber}`}
                component={selectYourNumber}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.callMeBack}`}
                component={callMeBack}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.simSwap}`}
                component={simSwap}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.balanceHistory}`}
                component={balanceHistory}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.giftSharing}`}
                component={giftSharing}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.selectGift}`}
                component={selectGift}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.gifts}`}
                component={Gifts}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.termsAndConditions}`}
                component={termsAndConditions}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.roaming.root}${PAGES_LINKS.service.roaming.international}`}
                component={InternationalRoaming}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.roaming.root}${PAGES_LINKS.service.roaming.international}${PAGES_LINKS.service.roaming.countryInfo}`}
                component={CountryInfoPage}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.roaming.root}${PAGES_LINKS.service.roaming.international}${PAGES_LINKS.service.roaming.tipsPage}`}
                component={TipsPage}
              />
              {/* Family Roaming routes disabled: redirect to International Roaming */}
              <Route
                exact
                path={'/service/roaming/family-roaming'}
                render={() => <Redirect to={'/service/roaming/international-roaming'} />}
              />
              <Route
                exact
                path={'/service/roaming/family-roaming/country-selection'}
                render={() => <Redirect to={'/service/roaming/international-roaming'} />}
              />
              <Route
                exact
                path={'/service/roaming/family-roaming/summary'}
                render={() => <Redirect to={'/service/roaming/international-roaming'} />}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.MCN}`}
                component={MCNPage}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.microLoans}`}
                component={microLoans}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.maddedha}`}
                component={Maddedha}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.simPukCode}`}
                component={SIMPUKCode}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.baringCalls}`}
                component={BaringCalls}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.connectYourLine}`}
                component={connectYourLine}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.recurringPayment}`}
                component={RecurringPayment}
              />

              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.recurringPaymentTerms}`}
                component={RecurringPaymentTerms}
              />

              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.zeroService.root}`}
                component={ZerosServicePage}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.zeroService.root}${PAGES_LINKS.service.zeroService.mobile}`}
                component={MobileZeros}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.zeroService.root}${PAGES_LINKS.service.zeroService.international}`}
                component={InternationalZeros}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.fixedLineServices.root}`}
                component={FixedLinesServicesPage}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.fixedLineServices.root}${PAGES_LINKS.service.fixedLineServices.changeLocation}`}
                component={ChangeLocationPage}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.fixedLineServices.root}${PAGES_LINKS.service.fixedLineServices.changeNumber}`}
                component={ChangeNumberPage}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.billServices.root}`}
                component={BillServicesPage}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.billServices.root}${PAGES_LINKS.service.billServices.eBill}`}
                component={EBillPage}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.billServices.root}${PAGES_LINKS.service.billServices.billviaSMS}`}
                component={BillviaSMS}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.serviceDetails.root}`}
                component={ServiceDetails}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.paltelBook.root}`}
                component={PaltelBook}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.newSubscriptionRequest.root}`}
                component={NewSubscriptionRequest}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.newSubscriptionRequest.root}${PAGES_LINKS.service.newSubscriptionRequest.otpVerification}`}
                component={OtpVerification}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.newSubscriptionRequest.root}${PAGES_LINKS.service.newSubscriptionRequest.map}`}
                component={NewSubscriptionRequestMap}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.fixedLineServices.root}${PAGES_LINKS.service.fixedLineServices.changeLocationTc}`}
                component={ChangeLocationTermsAndConditions}
              />

              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.fiberTool}`}
                component={FiberTool}
              />

              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.orderTracking.root}`}
                component={OrderTracking}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.orderTracking.root}${PAGES_LINKS.service.orderTracking.details}`}
                component={OrderTrackingDetails}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.points.root}`}
                component={Points}
              />

              {/* <PrivateLayout
              exact
              path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.safeInternet}`}
              component={safeInternetPage}
            /> */}
              <PrivateLayout
                exact
                path={PAGES_LINKS.profile}
                component={profile}
              />
              <PrivateLayout
                exact
                path={PAGES_LINKS.addReflectInfo}
                component={AddReflectInfo}
              />
              <PrivateLayout
                exact
                path={PAGES_LINKS.updateReflectInfo}
                component={AddReflectInfo}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.home.root}${PAGES_LINKS.home.plansDetails}`}
                component={PlanDetails}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.home.root}${PAGES_LINKS.home.payBills}`}
                component={PayBills}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.home.root}${PAGES_LINKS.home.installmentDetails}`}
                component={InsatllmentDetails}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.home.root}${PAGES_LINKS.home.payBills}${PAGES_LINKS.home.devices}`}
                component={devices}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.home.root}${PAGES_LINKS.home.billsDetailsPage}`}
                component={BillsDetailsPage}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.home.root}${PAGES_LINKS.home.RechargeBalance}`}
                component={RechargeBalance}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.home.root}${PAGES_LINKS.home.bundlePage}`}
                component={BundleDetailsPage}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.home.root}${PAGES_LINKS.home.offerDetailsPage}`}
                component={OfferDetailsPage}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.home.root}${PAGES_LINKS.home.allOffers}`}
                component={AllOffersPage}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.home.root}${PAGES_LINKS.home.campaignOfferNoGifts}`}
                component={CampaignOfferNoGiftsPage}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.home.root}${PAGES_LINKS.home.campaignOfferGifts}`}
                component={CampaignOfferGiftsPage}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.speedUpgradeADSL.root}`}
                component={SpeedUpgradeADSL}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.speedUpgradeADSL.root}${PAGES_LINKS.service.speedUpgradeADSL.speedUpgradeSummary}`}
                component={SpeedUpgradeSummary}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.home.root}${PAGES_LINKS.home.termsAndConditions}`}
                component={TermsAndConditions}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.fiber.root}`}
                component={Fiber}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.home.root}${PAGES_LINKS.home.fiberMigrationTC}`}
                component={FiberMigrationTermsConditions}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.superfastInternet.root}`}
                component={SuperfastInternet}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.superfastInternet.superfastInternetAddOns}`}
                component={SuperfastInternetAddOns}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.superfastInternet.superfastInternetSummary}`}
                component={SuperfastInternetSummary}
              />
              <PrivateLayout
                exact
                path={PAGES_LINKS.JPCallBack}
                component={JPCallBack}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.transactionHistory}`}
                component={TransactionHistory}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.home.root}${PAGES_LINKS.quickAccess.usage}`}
                component={usage}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.numberManagement}`}
                component={SwitchNumbers}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.cardsManagement}`}
                component={CardsManagement}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.aboutApp}`}
                component={AboutApp}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.jawwalApp}`}
                component={JawwalApps}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.settings}`}
                component={Settings}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.share}`}
                component={Share}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.supportAndHelp.root}`}
                component={SupportAndHelp}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.supportAndHelp.root}${PAGES_LINKS.more.supportAndHelp.rating}`}
                component={RatingPage}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.supportAndHelp.root}${PAGES_LINKS.more.supportAndHelp.showrooms}`}
                component={ShowRoomsPage}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.supportAndHelp.root}${PAGES_LINKS.more.supportAndHelp.callUs}`}
                component={CallUsPage}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.supportAndHelp.root}${PAGES_LINKS.more.supportAndHelp.followUp}`}
                component={FollowUpPage}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.supportAndHelp.root}${PAGES_LINKS.more.supportAndHelp.iframePage}`}
                component={SupportAndHelpIframePage}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.supportAndHelp.root}${PAGES_LINKS.more.supportAndHelp.trackYourOrder}`}
                component={OrderTracking}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.supportAndHelp.root}${PAGES_LINKS.more.supportAndHelp.fixedFollowUp}`}
                component={FixedFollowUpRouter}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.supportAndHelp.root}${PAGES_LINKS.more.supportAndHelp.troubleTicket}`}
                component={TroubleTicketPage}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.termsAndCondition}`}
                component={TermsAndCondition}
              />
              <Route
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.corporate.root}${PAGES_LINKS.more.corporate.mainPage}`}
                component={MainCorporatePage}
                isCorporate
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.corporate.root}`}
                component={MainCorporate}
                isCorporate
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.corporate.root}${PAGES_LINKS.more.corporate.addFollowUp}`}
                component={AddFollowUp}
                isCorporate
              />

              <PrivateLayout
                exact
                path={PAGES_LINKS.more.corporate.corpCheckoutInvoice}
                paymentInfoType="paymentComplete"
                paymentResultOpen={true}
                successLabel="successfullyPaid"
                successDescription={translation('successfullyPaidInvoiceJPay')}
                component={MainCorporate}
                isCorporate
                isJPAY
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.corporate.subRoot}`}
                component={SubAccountPage}
                isCorporate
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.corporate.subscriber}`}
                component={SubscribersPage}
                isCorporate
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.corporate.numberDetails}`}
                component={NumberDetails}
                isCorporate
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.corporate.orderNumbers}`}
                component={Orders}
                isCorporate
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.corporate.service.root}`}
                component={ServiceFiltrationPage}
                isCorporate
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.corporate.service.root}${PAGES_LINKS.more.corporate.service.lineService}`}
                component={CorporateLineService}
                isCorporate
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.corporate.service.root}${PAGES_LINKS.more.corporate.service.swipeSim}`}
                component={SwipeSim}
                isCorporate
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.corporate.service.root}${PAGES_LINKS.more.corporate.service.tempDeactivateAndReconnect}`}
                component={CorporateTempDeactivateAndReconnect}
                isCorporate
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.corporate.service.root}${PAGES_LINKS.more.corporate.service.individualUser}`}
                component={IndividualServicePage}
                isCorporate
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.paltelCorporate.root}`}
                component={PaltelMainCorporate}
                isCorporate
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.paltelCorporate.root}${PAGES_LINKS.more.paltelCorporate.paltelSubscribersPage}`}
                component={PaltelSubscribersPage}
                isCorporat
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.paltelCorporate.root}${PAGES_LINKS.more.paltelCorporate.accountInfo}`}
                component={PaltelAccountInfo}
                isCorporate
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.paltelCorporate.root}${PAGES_LINKS.more.paltelCorporate.addTroubleTicketFixedLine}`}
                component={AddTroubleTicketFixedLine}
                isCorporate
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.paltelCorporate.root}${PAGES_LINKS.more.paltelCorporate.addTroubleTicketDataIP}`}
                component={AddTroubleTicketDataIP}
                isCorporate
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.paltelCorporate.root}${PAGES_LINKS.more.paltelCorporate.invoiceDetails}`}
                component={InvoiceDetails}
                isCorporate
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.paltelCorporate.root}${PAGES_LINKS.more.paltelCorporate.orders}`}
                component={PaltelOrders}
                isCorporate
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.corporate.service.root}${PAGES_LINKS.more.corporate.service.lineInstallment}`}
                component={LineInstallmentPage}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.corporate.service.root}${PAGES_LINKS.more.corporate.service.directDebt}`}
                component={DirectDebtServicePage}
                isCorporate
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.corporate.service.root}${PAGES_LINKS.more.corporate.service.installations}`}
                component={PaltelInstallations}
                isCorporate
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.home.root}${PAGES_LINKS.quickAccess.freeSMS}`}
                component={FreeMessages}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.more.root}${PAGES_LINKS.more.deviceManagement}`}
                component={DeviceManagement}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.home.root}${PAGES_LINKS.quickAccess.quickAccess}`}
                component={quickAccess}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.home.root}${PAGES_LINKS.home.usage}`}
                component={UsageDetailsPage}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.ramadan.ramadanOffers}`}
                component={RamadanOffers}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.ramadan.ramadanBundlesBalances}`}
                component={RamadanBundlesBalances}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.ramadan.campaignDetails}`}
                component={CampaignDetails}
              />
              <PrivateLayout
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.routerSettings}`}
                component={RouterSettings}
              />
              <Route
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.uber}`}
                component={UberPage}
              />
              <Route
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.directDebt}`}
                component={DirectDebt}
              />
               <Route
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.buyForAnotherNumber}`}
                component={BundleGifting}
              />
               <Route
                exact
                path={`${PAGES_LINKS.service.root}${PAGES_LINKS.service.payBillsForOthers}`}
                component={PayBillsOthers}
              />

              <Route exact path={PAGES_LINKS.main} component={Main} />
              <Route exact path={'/test'} component={test} />
            </Switch>
          </HashRouter>
        </Suspense>
      </DirLayout>
    </>
  )
}

export default App
